import "moment/locale/id";
import { CurrencyFormat, formatDate, formatDate2, convertTwoDigit, formatTime, CountDown, formatDate3, formatTime2, formatTime3 } from "../../../components/helpers";
import moment from "moment";

export const convertJemputTerjadwal = (data) => {

    let converted = [];

    if (!data) return [];
    data.forEach((item, index) => {

        converted.push({
            key: index + 1,
            id: item?.id,
            tanggal_jemput_submit: moment(item?.pick_up_date).toString() || "-",
            tanggal_jemput: formatDate(item?.pick_up_date) || "-",
            tanggal_jemput_detail: moment(item?.pick_up_date).format('dddd DD MMMM YYYY') || "-",
            tanggal_jemput_edit: formatDate3(item?.pick_up_date) || "-",
            waktu_jemput: formatTime(item?.pick_up_date) || "-",
            jam_jemput: formatTime2(item?.pick_up_date) || "-",
            menit_jemput: formatTime3(item?.pick_up_date) || "-",
            nama_nasabah: item?.gadai.ktp_name || "-",
            no_telp: item?.gadai?.phone_1 || "-",
            barang_jaminan: item?.gadai?.gadai_type || "-",
            alamat: item?.address || "-",
            lokasi_jemput: `${item?.address} ${item?.subdistrict} ${item?.city} ${item?.province}` || "-",
            konfirmasi: CountDown(item?.gadai.due_date) || "-",
            kode_gadai: item?.gadai_id || "-",
            outlet_id: item?.gadai.outlet_id || "-",
            kode_kurir: item?.employee_id || "-",
            nama_kurir: `${item?.employee?.first_name} ${item?.employee?.last_name}` || "-",
            status: (item?.status == "valuation-done") ? "Jadwal Terkonfirmasi" : (item?.status == "waiting-valuation") ? "Menunggu Valuasi" : (item?.status == "confirmed") ? "Jadwal terkonfirmasi" : (item?.status == "declined") ? "Dibatalkan" : (item?.status == "waiting-for-confirmation") ? "Menunggu Konfirmasi" : "-",
            no_kurir: item?.employee?.phone || "-",
            gadai_picture: item?.gadai?.gadai_product_pictures || "-",
            outlet_name: !item?.gadai?.outlet?.name ? "-" : item?.gadai?.outlet?.name,
            imei: item?.gadai?.gadai_smartphone?.imei_number,
        });
    });
    return converted;
};
